<template>
  <div class="p-1">
    <div class="stats-section shadow">
      <div class="balance-due-bar" />
      <div class="d-flex align-items-end justify-content-between">
        <div class="p-1">
          <h6 class="stats-section-title mt-2">Balance due</h6>
          <span class="primary-sum">
            {{ sums.balance }}
          </span>
        </div>
        <div class="d-flex flex-column p-1">
          <span class="balance-due-average-label">Avg</span>
          <span class="balance-due-average-amount">{{ averages.balance }}</span>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between border-top">
        <div class="w-50 d-flex align-items-end justify-content-between ml-3">
          <div class="p-1">
            <h6 class="stats-section-title mt-2">Company profit</h6>
            <span class="secondary-sum">
              {{ sums.carrier_total }}
            </span>
          </div>
          <div class="d-flex flex-column p-1">
            <span class="balance-due-average-label">Avg</span>
            <span class="balance-due-average-amount">{{ averages.carrier_total }}</span>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between border-top">
        <div class="w-50 d-flex align-items-end justify-content-between mr-3">
          <div class="p-1">
            <h6 class="stats-section-title mt-2">Cluster profit</h6>
            <span class="secondary-sum">
              {{ sums.cluster_total }}
            </span>
          </div>
          <div class="d-flex flex-column p-1">
            <span class="balance-due-average-label">Avg</span>
            <span class="balance-due-average-amount">{{ averages.cluster_total }}</span>
          </div>
        </div>
      </div>


      <div class="stats-section shadow mt-3">
        <div class="grand-total-bar" />
        <div class="d-flex align-items-end justify-content-between">
          <div class="p-1">
            <h6 class="stats-section-title mt-2">Grand total</h6>
            <span class="primary-sum">
              {{ sums.total_price }}
            </span>
          </div>
          <div class="d-flex flex-column p-1">
            <span class="grand-total-average-label">Avg</span>
            <span class="grand-total-average-amount">{{ averages.total_price }}</span>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-between border-top">
          <div class="w-50 d-flex align-items-end justify-content-between mr-3">
            <div class="p-1">
              <h6 class="stats-section-title mt-2">Cash</h6>
              <span class="secondary-sum">
                {{ sums.cash_payment }}
              </span>
            </div>
            <div class="d-flex flex-column p-1">
              <span class="grand-total-average-label">Avg</span>
              <span class="grand-total-average-amount">{{ averages.cash_payment }}</span>
            </div>
          </div>
          <div class="w-50 d-flex align-items-end justify-content-between ml-3">
            <div class="p-1">
              <h6 class="stats-section-title mt-2">Credit</h6>
              <span class="secondary-sum">
                {{ sums.total_credit }}
              </span>
            </div>
            <div class="d-flex flex-column p-1">
              <span class="grand-total-average-label">Avg</span>
              <span class="grand-total-average-amount">{{ averages.total_credit }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between mt-3">
        <div class="stats-section w-50 mr-2 shadow">
          <div class="deposit-total-bar" />
          <div class="d-flex align-items-end justify-content-between">
            <div class="p-1">
              <h6 class="stats-section-title mt-2">Deposit</h6>
              <span class="secondary-sum">
                {{ sums.deposit }}
              </span>
            </div>
            <div class="d-flex flex-column p-1">
              <span class="deposit-total-average-label">Avg</span>
              <span class="deposit-total-average-amount">{{ averages.balance }}</span>
            </div>
          </div>
        </div>

        <div class="stats-section w-50 ml-2 shadow">
          <div class="tips-total-bar" />
          <div class="d-flex align-items-end justify-content-between">
            <div class="p-1">
              <h6 class="stats-section-title mt-2">Tips</h6>
              <span class="secondary-sum">
                {{ sums.card_tips }}
              </span>
            </div>
            <div class="d-flex flex-column p-1">
              <span class="tips-total-average-label">Avg</span>
              <span class="tips-total-average-amount">{{ averages.card_tips }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between mt-3">
        <div class="stats-section w-50 mr-2 shadow">
          <div class="time-total-bar" />
          <div class="d-flex align-items-end justify-content-between">
            <div class="p-1">
              <h6 class="stats-section-title mt-2">Time</h6>
              <span class="secondary-sum">
                {{ sums.time }}
              </span>
            </div>
            <div class="d-flex flex-column p-1">
              <span class="time-total-average-label">Avg</span>
              <span class="time-total-average-amount">{{ averages.time }}</span>
            </div>
          </div>
        </div>

        <div class="w-50 ml-2" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TotalsStatisticMobile',
  props: {
    sums: {
      type: Object,
      default: () => {},
    },
    averages: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped>
.stats-section {
  background-color: #fff;
  border-radius: 10px;
  min-height: 50px;
  padding: 10px;
  border: 1px solid #d9d9d9;
}

.primary-sum {
  color: black;
  font-weight: 600;
  font-size: 20px;
}

.secondary-sum {
  color: black;
  font-weight: 600;
  font-size: 17px;
}

.stats-section-title {
  color: #949aa5;
  font-size: 15px;
  font-weight: 500;
}

.balance-due-bar {
  background-color: #ff3333;
  height: 7px;
  width: 100%;
  border-radius: 3px;
}

.balance-due-average-label {
  text-transform: uppercase;
  font-size: 0.5rem;
  text-align: right;
  color: #ff3333;
  margin-bottom: -5px;
}

.balance-due-average-amount {
  text-transform: uppercase;
  font-size: 0.8rem;
  text-align: right;
  color: #ff3333;
}

.grand-total-average-label {
  text-transform: uppercase;
  font-size: 0.5rem;
  text-align: right;
  color: #5481ff;
  margin-bottom: -5px;
}

.grand-total-average-amount {
  text-transform: uppercase;
  font-size: 0.8rem;
  text-align: right;
  color: #5481ff;
}

.grand-total-bar {
  background-color: #5481ff;
  height: 7px;
  width: 100%;
  border-radius: 3px;
}

.deposit-total-average-label {
  text-transform: uppercase;
  font-size: 0.5rem;
  text-align: right;
  color: #33ccb7;
  margin-bottom: -5px;
}

.deposit-total-average-amount {
  text-transform: uppercase;
  font-size: 0.8rem;
  text-align: right;
  color: #33ccb7;
}

.deposit-total-bar {
  background-color: #33ccb7;
  height: 7px;
  width: 100%;
  border-radius: 3px;
}

.tips-total-average-label {
  text-transform: uppercase;
  font-size: 0.5rem;
  text-align: right;
  color: #ffbc33;
  margin-bottom: -5px;
}

.tips-total-average-amount {
  text-transform: uppercase;
  font-size: 0.8rem;
  text-align: right;
  color: #ffbc33;
}

.tips-total-bar {
  background-color: #ffbc33;
  height: 7px;
  width: 100%;
  border-radius: 3px;
}

.time-total-average-label {
  text-transform: uppercase;
  font-size: 0.5rem;
  text-align: right;
  color: #757575;
  margin-bottom: -5px;
}

.time-total-average-amount {
  text-transform: uppercase;
  font-size: 0.8rem;
  text-align: right;
  color: #757575;
}

.time-total-bar {
  background-color: #757575;
  height: 7px;
  width: 100%;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/TotalsStatisticsMobile.vue